"use client";
import { forgotSchema } from "@/utils/validation/SignupSchema";
import { InputField } from "@/components/ui";
import { Formik, Form } from "formik";
import { useRouter } from "next/navigation";
import { Loader } from "@/components/ui";
import { forgotPassword, getForgotPasswordLoading } from "@/lib/features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "@/lib/hooks";

interface FormValues {
  email: string;
}
const ForgotPasswordForm = () => {
  const isLoading = useAppSelector(getForgotPasswordLoading);
  const dispatch = useAppDispatch();
  const initialValues: FormValues = {
    email: "",
  };
  const onSubmit = async (data: FormValues) => {
    dispatch(
      forgotPassword({ url: "v1/auth/user/forgot-password", payload: data })
    );
  };
  //

  return (
    <>
      {isLoading && <Loader show={isLoading} />}
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={forgotSchema}
        onSubmit={onSubmit}
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form className="row y-gap-20">
            {/* {JSON.stringify(errors)} */}

            <div className="col-12">
              <h1 className="text-22 fw-500">Forgot Password</h1>
            </div>
            {/* {JSON.stringify(username)}
    {JSON.stringify(password)} */}
            <div className="col-12">
              <InputField name="email" label="Email" type="email" />
            </div>
            {/* End .col */}

            <div className="col-12">
              <button
                type="submit"
                className="button py-20 -dark-1 bg-blue-1 text-white w-100"
              >
                Submit
              </button>
            </div>
            {/* End .col */}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ForgotPasswordForm;
